export enum DdEventCategory {
  Geolocation = 'GEOLOCATION',
  GameLaunch = 'GAME_LAUNCH',
  GameContext = 'GAME_CONTEXT',
  ProviderIntegration = 'PROVIDER_INTEGRATION',
  Initialization = 'GW_INIT',
  UpdateGeolocation = 'UPDATE_GEOLOCATION',
  UpdateAuthentication = 'UPDATE_AUTHENTICATION',
  UserInteraction = 'USER_INTERACTION',
  ProviderLocationCheck = 'PROVIDER_LOCATION_CHECK',
  NetPosition = 'NET_POSITION',
  Trending = 'TRENDING',
  Network = 'NETWORK',
  RewardMachine = 'REWARD_MACHINE',
  Session = 'SESSION',
  ErrorHandling = 'POPUP_ERROR',
  JackpotRecon = 'JACKPOT_RECON',
  GameSwitch = 'GAME_SWITCH',
  Wallet = 'WALLET',
}

export enum DdEventType {
  Success = 'SUCCESS',
  Error = 'ERROR',
  Info = 'INFO',
  Action = 'ACTION',
}

export type DdEvent = {
  name: string;
  description?: string;
  payload?: Record<string, unknown>;
  useCase: DdEventCategory;
  eventType: DdEventType;
  event?: DdEventAttributes;
  logOnly?: boolean;
};

export type DdAction = DdEvent & {
  context?: Record<string, unknown>;
  service?: string;
};

export type DdError = DdEvent & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  context?: Record<string, any>;
  stack?: string;
  service?: string;
};

export type DatadogSite =
  | 'datadoghq.com'
  | 'datadoghq.eu'
  | 'us3.datadoghq.com'
  | 'us5.datadoghq.com'
  | 'ddog-gov.com';

export type DdEventAttributes = {
  action: string;
  log_code: DdEventAttributesCode;
} & DdEventAttributesFields;

export enum DdEventAttributesCodePrefix {
  GameLaunch = 'GL',
  GameWindow = 'GW',
  SiteWideJackpot = 'SWJ',
  NetPosition = 'NP',
  GameSwitch = 'GS',
}

export enum DdEventAttributesLifecycle {
  Init = 1,
  Success = 2,
  Info = 3,
  Decision = 4,
  Failure = 5,
}

export type DdEventAttributesSubcategory = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export type DdEventAttributesTiebreaker = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9;

export type DdEventAttributesCode =
  `${DdEventAttributesCodePrefix}-${DdEventAttributesLifecycle}${DdEventAttributesSubcategory}${DdEventAttributesTiebreaker}`;

export enum DdEventAttributesFailureType {
  ConnectFailure = 'connect_failure',
  Timeout = 'timeout',
  HttpError = 'http_error',
  ParseError = 'parse_error',
  AuthFailure = 'auth_failure',
}

export type DdEventAttributesFields = Record<
  string,
  string | number | boolean | string[] | undefined
>;
